import React from 'react';
import '../../css/buttons/Tags.css';

import { IoChatboxEllipses } from 'react-icons/io5';
import { useDispatch } from 'react-redux';

import { openCounseling } from '../../features/counseling';

const Tags = ({ name }) => {
	const dispatch = useDispatch();

	return (
		<button
			className={'Tags'}
			onClick={() => {
				dispatch(openCounseling());
			}}
		>
			<span className='tag-name'>{name}</span>
			<span className={'tags-circle'}>
				<IoChatboxEllipses />
			</span>
		</button>
	);
};

export default Tags;
